<template>
    <i v-if="kit === 'fa'" :class="['fa' + weight, 'fa-' + name]"></i>
</template>

<script>
    export default {
        name: "icon",
        props: {
            name: {
                type: String,
                default: "border-inner",
                require: true
            },
            kit: {
                type: String,
                default: 'fa'
            },
            weight: {
                type: String,
                default: 's'
            }
        }
    }
</script>